export type Language = 'cs' | 'sk' | 'hu';

interface CurrencyConfig {
	locale: string;
	currency: string;
}

export const currencyConfig: Record<Language, CurrencyConfig> = {
	cs: {
		locale: 'cs-CZ',
		currency: 'CZK',
	},
	sk: {
		locale: 'sk-SK',
		currency: 'EUR',
	},
	hu: {
		locale: 'hu-HU',
		currency: 'HUF',
	},
};
